/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ monthlyPrice: NonNullable<unknown>, yearlyPrice: NonNullable<unknown> }} Dialog_Premium_Pricing_TrialInputs */

const en_dialog_premium_pricing_trial = /** @type {(inputs: Dialog_Premium_Pricing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After the free trial, it's ${i?.monthlyPrice}/mo or ${i?.yearlyPrice}/year. Cancel any time, no commitment.`)
};

const es_dialog_premium_pricing_trial = /** @type {(inputs: Dialog_Premium_Pricing_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después de la prueba gratuita, son ${i?.monthlyPrice}/mes o ${i?.yearlyPrice}/año. Cancela en cualquier momento, sin compromiso.`)
};

/**
* | output |
* | --- |
* | "After the free trial, it's {monthlyPrice}/mo or {yearlyPrice}/year. Cancel any time, no commitment." |
*
* @param {Dialog_Premium_Pricing_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_pricing_trial = /** @type {((inputs: Dialog_Premium_Pricing_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Pricing_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_pricing_trial(inputs)
	return en_dialog_premium_pricing_trial(inputs)
});